module.exports = __webpack_public_path__ + "img/screen-1.84c6c460.jpg";